import { ArrowCircle } from "components/icons/generated";
import Banner from "ds/components/Banner";
import Button from "ds/components/Button";
import FeedbackActions from "ds/components/Feedback/Actions";
import Link from "ds/components/Link";
import { pluralizeNext } from "shared/Pluralize";

import { DASHBOARD_WIDGETS_STACKS_REQUIRING_ATTENTION_MIGRATION_GUIDE_URL } from "../constants";

type DashboardWidgetsStacksRequiringAttentionMigratedCalloutProps = {
  migrated: number;
  onRollback: () => void;
  migrateLoading: boolean;
  rollbackLoading: boolean;
  showMigrationGuideLink: boolean;
};

const DashboardWidgetsStacksRequiringAttentionMigratedCallout = ({
  migrated,
  onRollback,
  migrateLoading,
  rollbackLoading,
  showMigrationGuideLink,
}: DashboardWidgetsStacksRequiringAttentionMigratedCalloutProps) => {
  return (
    <Banner variant="info" fullWidth>
      {pluralizeNext(migrated, "stack")} already migrated to Spacelift-native Terragrunt. If
      you&apos;re having issues, you can roll them back to Terraform.
      <FeedbackActions>
        <Button
          variant="secondary"
          size="small"
          startIcon={ArrowCircle}
          onPress={onRollback}
          loading={rollbackLoading}
          disabled={migrateLoading}
        >
          Rollback to Terraform
        </Button>
        {showMigrationGuideLink && (
          <Link
            size="small"
            href={DASHBOARD_WIDGETS_STACKS_REQUIRING_ATTENTION_MIGRATION_GUIDE_URL}
            target="_blank"
          >
            Terragrunt migration guide
          </Link>
        )}
      </FeedbackActions>
    </Banner>
  );
};

export default DashboardWidgetsStacksRequiringAttentionMigratedCallout;
